"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeRewardDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("./Dataset");
class StakeRewardDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.create = (this.sendRequest(interfaces_1.WEN_FUNC.stakeReward));
        this.remove = (this.sendRequest(interfaces_1.WEN_FUNC.removeStakeReward));
        this.getByTokenLive = (token, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['token'],
                fieldValue: [token],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['endDate'],
                orderByDir: ['asc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.StakeRewardDataset = StakeRewardDataset;
